export const styles = {
  page: {
    justifyContent: "flex-start",
  },
  children: {
    justifyContent: "flex-start",
  },
  paper: {
    padding: "16px !important",
    width: "360px",
    borderRadius: "8px",
  },
};
